import React__default from "react";
import { Fittext } from "../../fittext/fittext.mjs";
import { Heading } from "../../typography/heading/heading.mjs";
const BannerHeading = (props) => {
  const { children, ...other } = props;
  return /* @__PURE__ */ React__default.createElement("div", { className: "banner__heading" }, /* @__PURE__ */ React__default.createElement(Heading, { ...other }, /* @__PURE__ */ React__default.createElement(Fittext, null, children)));
};
export {
  BannerHeading
};
